import { FieldType, RulesConfiguration } from 'controls/queryBuilder/ruleDefinition';
import { DataHolder } from 'framework/data-loading/dataHolder';

import { TimeColumnsInfo, TimePeriodSettingsSectionProps } from './types';

const DefaultTimeColumnName = 'time';

export function getTimeColumns(rulesConfiguration: DataHolder<RulesConfiguration>): TimeColumnsInfo {
	const rules = rulesConfiguration.data ?? {};

	return {
		loaded: rulesConfiguration.loaded,
		options: Object.keys(rules)
			.filter((key) => rules[key].type == FieldType.Date)
			.map((key) => ({ value: key, label: rules[key].label ?? key })),
	};
}

export function applyTimeColumnDefaults(
	timeColumns: TimeColumnsInfo,
	store: TimePeriodSettingsSectionProps['store'],
	model: TimePeriodSettingsSectionProps['model'],
) {
	if (!timeColumns.loaded) return;

	if (!timeColumns.options.length) {
		store.enableTimeSelector = false;
		model.timePeriodColumn = undefined;
		return;
	}

	if (timeColumns.options.some((x) => x.value == model.timePeriodColumn)) return;

	const isDefault = (text: unknown) => typeof text == 'string' && text.toLowerCase() == DefaultTimeColumnName;
	const option = timeColumns.options.find((x) => isDefault(x.label) || isDefault(x.value));
	model.timePeriodColumn = option ? String(option.value) : undefined;
}
